import {
  Home,
  Construction,
  CloudRain,
  Trees,
  Building2,
  Droplets,
  Truck,
  ArrowUpRight,
} from "lucide-react";

const services = [
  {
    id: "vehicle",
    icon: Truck,
    title: "Trucks & Heavy Equipment",
    desc: "From box trucks to excavators. Mobile fleet washing on-site, on your schedule.",
    image: "https://images.unsplash.com/photo-1587102616279-827acbb3f526",
    span: "lg:col-span-8 lg:row-span-2",
    featured: true,
  },
  {
    id: "house",
    icon: Home,
    title: "House & Siding",
    desc: "Vinyl, brick, stucco — restored without damage. Soft-wash safe for your home's exterior.",
    image: "https://images.unsplash.com/photo-1761653457979-8cba6c081246",
    span: "lg:col-span-4 lg:row-span-1",
  },
  {
    id: "driveway",
    icon: Construction,
    title: "Driveways & Concrete",
    desc: "Oil stains, mildew, ground-in grime. Surface-cleaned to factory finish.",
    image: null,
    span: "lg:col-span-4 lg:row-span-1",
  },
  {
    id: "roof",
    icon: CloudRain,
    title: "Soft-Wash Roof Cleaning",
    desc: "Black streaks and moss removed. Low-pressure, shingle-safe formula.",
    image: null,
    span: "lg:col-span-4 lg:row-span-1",
  },
  {
    id: "deck",
    icon: Trees,
    title: "Decks, Patios & Fences",
    desc: "Wood, composite, stone — prepped clean for staining or just looking sharp.",
    image: null,
    span: "lg:col-span-4 lg:row-span-1",
  },
  {
    id: "commercial",
    icon: Building2,
    title: "Commercial Properties",
    desc: "Storefronts, plazas, parkades, dumpster pads. Recurring contracts welcome.",
    image: "https://images.unsplash.com/photo-1768268004429-e59aeea1b932",
    span: "lg:col-span-8 lg:row-span-1",
  },
  {
    id: "gutter",
    icon: Droplets,
    title: "Gutter Cleaning",
    desc: "Inside and out. Cleared, flushed, and brightened — protect your foundation.",
    image: null,
    span: "lg:col-span-4 lg:row-span-1",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 border-b border-[#2A2A2A]"
    >
      <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
        <div className="lg:col-span-7">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#FFD600]">
            01 — What We Wash
          </span>
          <h2 className="font-display font-bold uppercase tracking-tight leading-[0.9] text-4xl sm:text-5xl lg:text-6xl mt-4">
            Seven services.
            <br />
            One filthy enemy.
          </h2>
        </div>
        <div className="lg:col-span-5">
          <p className="text-base text-gray-400 leading-relaxed">
            Every job gets the same approach — proper chemistry, the right pressure, and crews that
            actually care if it looks good when we leave. No upsells, no surprises.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
        {services.map((s) => {
          const Icon = s.icon;
          return (
            <a
              key={s.id}
              href="#quote"
              data-testid={`service-card-${s.id}`}
              className={`group relative bg-[#0A0A0A] hover:bg-[#101010] p-8 md:p-10 min-h-[260px] flex flex-col justify-between transition-colors overflow-hidden ${s.span || ""}`}
            >
              {s.image && (
                <div
                  className="absolute inset-0 bg-cover bg-center opacity-15 group-hover:opacity-30 transition-opacity"
                  style={{ backgroundImage: `url('${s.image}')` }}
                  aria-hidden
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-tr from-black via-transparent to-transparent" aria-hidden />

              <div className="relative z-10 flex items-start justify-between">
                <div className="w-12 h-12 border border-[#2A2A2A] group-hover:border-[#FFD600] flex items-center justify-center transition-colors">
                  <Icon size={22} strokeWidth={2} className="text-[#FFD600]" />
                </div>
                <ArrowUpRight
                  size={22}
                  className="text-gray-500 group-hover:text-[#FFD600] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                />
              </div>

              <div className="relative z-10 mt-10">
                {s.featured && (
                  <span className="inline-block text-[10px] font-bold uppercase tracking-[0.3em] text-[#00E5FF] mb-3">
                    ★ Specialty
                  </span>
                )}
                <h3 className="font-display font-bold uppercase tracking-tight text-2xl md:text-3xl leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-gray-400 leading-relaxed max-w-md">{s.desc}</p>
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}
